




























import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { InvoiceParty } from "@/models/invoice-party.entity";
import { IReference } from "@/models/reference.entity";
import { IRepairEstimateRequest, RepairEstimateRequest } from "@/models/repair-estimate-request.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import RepairEstimateRequestCreateStepper, { RepairEstimateSteps } from "./RepairEstimateRequestCreateStepper.vue";

@Component({
  components: {
    RepairEstimateRequestCreateStepper,
    ConfirmActionDialog
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateRequestCreateDialog extends mixins(PermissionMixin) implements IDialog {
  @Ref("requestRepairEstimateStepper")
  requestRepairEstimateStepper!: RepairEstimateRequestCreateStepper;

  @Prop()
  partnerId!: string;

  @Prop()
  hideButton!: boolean;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop({ default: false })
  hideRefsSelect!: boolean;

  isDialogActive = false;

  isLoading = false;

  requestsLoading = false;

  step = RepairEstimateSteps.SELLER;

  value: IRepairEstimateRequest = new RepairEstimateRequest({
    partnerId: this.partnerId,
    seller: new InvoiceParty(),
    refs: this.refs
  });

  get steps() {
    return new Map([
      [
        RepairEstimateSteps.SELLER,
        {
          title: this.$t("repairEstimateRequest.request"),
          backText: $t("close"),
          nextText: $t("next"),
          loading: false,
          disabled: !this.value?.seller.ref?.refId,
          back: () => {
            this.close();
          },
          next: () => {
            this.step = RepairEstimateSteps.SHARING;
          }
        }
      ],
      [
        RepairEstimateSteps.SHARING,
        {
          title: this.$t("repairEstimateRequest.share"),
          backText: $t("back"),
          nextText: $t("next"),
          loading: this.requestsLoading,
          back: () => {
            this.step = RepairEstimateSteps.SELLER;
          },
          next: async () => {
            this.requestsLoading = true;
            await this.requestRepairEstimateStepper?.createRequests();
            this.requestsLoading = false;
          }
        }
      ],
      [
        RepairEstimateSteps.SEND_MAIL,
        {
          title: this.$t("repairEstimateRequest.sendMail"),
          backText: $t("close"),
          nextText: $t("repairEstimateRequest.sendMail"),
          loading: false,
          back: () => {
            this.close();
          },
          next: async () => {
            try {
              await this.requestRepairEstimateStepper?.templateCard.send();
              await this.value.updatePartial({
                status: RequestStatusEnum.REQUESTED
              });
              this.step = RepairEstimateSteps.SUCCESS;
            } catch (e) {
              handleError(e);
            }
          }
        }
      ],
      [
        RepairEstimateSteps.SUCCESS,
        {
          title: this.$t("repairEstimateRequest.success"),
          backText: $t("repairEstimateRequest.requestAnother"),
          nextText: $t("close"),
          loading: false,
          back: () => {
            this.value = new RepairEstimateRequest({
              partnerId: this.partnerId,
              seller: new InvoiceParty(),
              refs: this.refs
            });
            this.step = RepairEstimateSteps.SELLER;
          },
          next: () => {
            this.close();
          }
        }
      ]
    ]);
  }

  get currentStep() {
    return this.steps.get(this.step);
  }

  open() {
    this.value = new RepairEstimateRequest({
      partnerId: this.partnerId,
      seller: new InvoiceParty(),
      refs: this.refs
    });
    if (this.requestRepairEstimateStepper) {
      this.value.seller = new InvoiceParty();
    }
    this.step = RepairEstimateSteps.SELLER;
    this.isDialogActive = true;
  }

  async openShareExisting(repairEstimateRequest: IRepairEstimateRequest) {
    this.open();

    this.$nextTick(() => {
      if (this.requestRepairEstimateStepper) {
        this.value = repairEstimateRequest;
        this.requestRepairEstimateStepper.stepLocal = RepairEstimateSteps.SHARING;
      }
    });
  }

  close() {
    this.step = RepairEstimateSteps.SELLER;
    this.isLoading = false;
    this.value = new RepairEstimateRequest({
      partnerId: this.partnerId,
      seller: new InvoiceParty(),
      refs: this.refs
    });
    this.isDialogActive = false;
  }
}
